import { defineNuxtPlugin } from '#app/nuxt'
import { LazyESGCalculator, LazyPriorityItem, LazyPriorityWrapper, LazyReportsWrapper, LazyStructuredFinancialReports, LazyStructuredFinancialReportsGroup, LazyWosWrapper, LazyWwdnItem, LazyWwdnWrapper, LazyIlluminatorItem, LazyIlluminatorWrapper, LazyMainWrapper, LazyAchievement, LazyAnchorWrapper, LazyBanner, LazyBannerBlock, LazyBannerWithIcon, LazyButton, LazyButtonAddToCalendar, LazyButtonDownload, LazyButtonFullWidth, LazyCard, LazyCards, LazyColumnElement, LazyCompanyHistory, LazyContactRow, LazyCsvToJson, LazyDescriptionBlock, LazyEventCards, LazyFinancialReports, LazyFinancialResults, LazyFourColumns, LazyGrayBlock, LazyHeading, LazyHeadingAndDescription, LazyHeroCardPageInfo, LazyImageBanner, LazyIndexCard, LazyLatestNewsAndAnnouncements, LazyPressBanner, LazyPressReleases, LazyProfileCard, LazyScopeAndAchievements, LazySideBySide, LazySingleFinancialReport, LazySlider, LazyStatisticCardBlok, LazyTable, LazyThreeColumns, LazyTwoColumns, LazyUpcomingEvents, LazyVideoBanner, LazyXlsxToJson, LazyBlockDivider, LazyLinkItem, LazyContentHero, LazyHeroBanner, LazyCiStaticPage, LazyImageContent, LazyBackgroundWrapper } from '#components'
const lazyGlobalComponents = [
  ["ESGCalculator", LazyESGCalculator],
["PriorityItem", LazyPriorityItem],
["PriorityWrapper", LazyPriorityWrapper],
["ReportsWrapper", LazyReportsWrapper],
["StructuredFinancialReports", LazyStructuredFinancialReports],
["StructuredFinancialReportsGroup", LazyStructuredFinancialReportsGroup],
["WosWrapper", LazyWosWrapper],
["WwdnItem", LazyWwdnItem],
["WwdnWrapper", LazyWwdnWrapper],
["IlluminatorItem", LazyIlluminatorItem],
["IlluminatorWrapper", LazyIlluminatorWrapper],
["MainWrapper", LazyMainWrapper],
["Achievement", LazyAchievement],
["AnchorWrapper", LazyAnchorWrapper],
["Banner", LazyBanner],
["BannerBlock", LazyBannerBlock],
["BannerWithIcon", LazyBannerWithIcon],
["Button", LazyButton],
["ButtonAddToCalendar", LazyButtonAddToCalendar],
["ButtonDownload", LazyButtonDownload],
["ButtonFullWidth", LazyButtonFullWidth],
["Card", LazyCard],
["Cards", LazyCards],
["ColumnElement", LazyColumnElement],
["CompanyHistory", LazyCompanyHistory],
["ContactRow", LazyContactRow],
["CsvToJson", LazyCsvToJson],
["DescriptionBlock", LazyDescriptionBlock],
["EventCards", LazyEventCards],
["FinancialReports", LazyFinancialReports],
["FinancialResults", LazyFinancialResults],
["FourColumns", LazyFourColumns],
["GrayBlock", LazyGrayBlock],
["Heading", LazyHeading],
["HeadingAndDescription", LazyHeadingAndDescription],
["HeroCardPageInfo", LazyHeroCardPageInfo],
["ImageBanner", LazyImageBanner],
["IndexCard", LazyIndexCard],
["LatestNewsAndAnnouncements", LazyLatestNewsAndAnnouncements],
["PressBanner", LazyPressBanner],
["PressReleases", LazyPressReleases],
["ProfileCard", LazyProfileCard],
["ScopeAndAchievements", LazyScopeAndAchievements],
["SideBySide", LazySideBySide],
["SingleFinancialReport", LazySingleFinancialReport],
["Slider", LazySlider],
["StatisticCardBlok", LazyStatisticCardBlok],
["Table", LazyTable],
["ThreeColumns", LazyThreeColumns],
["TwoColumns", LazyTwoColumns],
["UpcomingEvents", LazyUpcomingEvents],
["VideoBanner", LazyVideoBanner],
["XlsxToJson", LazyXlsxToJson],
["BlockDivider", LazyBlockDivider],
["LinkItem", LazyLinkItem],
["ContentHero", LazyContentHero],
["HeroBanner", LazyHeroBanner],
["CiStaticPage", LazyCiStaticPage],
["ImageContent", LazyImageContent],
["BackgroundWrapper", LazyBackgroundWrapper],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
